import Take from "../../models/Take";
import Take3D, { getTake3DSequence } from "../../models/Take3D";

export function getValidationEntityIds(takes: Take[]): Set<string> {
  return new Set(
    takes.flatMap((take) => {
      // Disabled interactions are excluded from test payloads, so their
      // errors must not block the test buttons.
      const ids = (take.interactions ?? [])
        .filter((interaction) => interaction.disabled !== true)
        .map((interaction) => interaction.id);
      const takeSequence = getTake3DSequence(
        take as Partial<Take3D> as Pick<Take3D, "sequence">
      );

      return takeSequence ? [...ids, takeSequence.id] : ids;
    })
  );
}

export function hasBlockingValidationErrors(
  takes: Take[],
  allErrors: Record<string, unknown[]>
) {
  const validEntityIds = getValidationEntityIds(takes);
  return Object.entries(allErrors).some(
    ([interactionId, errors]) =>
      validEntityIds.has(interactionId) && errors.length > 0
  );
}
